<template>
  <el-row
    id="print"
    type="flex"
    justify="center"
  >
    <el-col
      :xs="{ span: 22 }"
      :sm="{ span: 18 }"
      :md="{ span: 14 }"
    >
      <el-row
        type="flex"
        class="text-block"
      >
        <el-col :span="9">
          <el-row
            type="flex"
          >
            <el-col class="text-left">
              <b>Swapper Name:</b> {{ selectedShopper.first_name }} {{ selectedShopper.last_name }}
            </el-col>
          </el-row>
          <el-row
            type="flex"
          >
            <el-col class="text-left">
              <b>Email:</b> {{ selectedShopper.email_address }}
            </el-col>
          </el-row>
          <el-row
            type="flex"
          >
            <el-col class="text-left">
              <b>Phone:</b> {{ $helpers.phoneMask(selectedShopper.phone_number) }}
            </el-col>
          </el-row>
        </el-col>
        <el-col
          :span="6"
          class="text-center"
        >
          <el-button
            class="hide-on-print"
            type="default"
            icon="el-icon-s-home"
            circle
            @click="goHome"
          />
          <el-button
            class="hide-on-print"
            type="default"
            icon="el-icon-printer"
            circle
            @click="print"
          />
        </el-col>
        <el-col :span="9">
          <el-row
            type="flex"
          >
            <el-col class="text-right">
              <b>Swapper Action:</b>
              {{ selectedShopper.transaction.action === "buyers_remorse" ? "Returned Item" : "Donate or Recycle" }}
            </el-col>
          </el-row>
          <el-row
            type="flex"
          >
            <el-col class="text-right">
              <b>Date:</b> {{ $helpers.formatDate({
                date: selectedShopper.transaction.timestamp,
                inFormat: '',
                outFormat: 'MM/DD/YYYY hh:mm A'
              }) }}
            </el-col>
          </el-row>
        </el-col>
      </el-row>
      <el-row>
        <el-col
          class="text-block"
        >
          <h3
            class="text-center logo-and-title"
          >
            <img
              style="height: 50px;"
              src="@/assets/labelswap_logo.png"
              alt="Labelswap logo"
            >
            <strong>labelswap™</strong> BUY POLICY:
          </h3>

          <h5><strong>labelswap™</strong> TERMS OF SERVICE:</h5>

          <ul class="list custom-bullet">
            <li>
              SWAPPERS AGREE TO SELL THEIR ITEMS FOR THE PRICE SET BY <strong>labelswap™</strong> OR ACCEPT THE SWAP VALUE PROVIDED
              BY <strong>labelswap™</strong> AT THE TIME OF THE TRANSACTION.  SWAP VALUE CAN BE USED IMMEDIATELY OR HELD AT THE STORE
              FOR A MAXIMUM OF 12 MONTHS.
            </li>
            <li>
              SWAPPERS AUTHORIZE <strong>labelswap™</strong> TO CHOOSE, TAG, AND SELL THE ITEMS THEY SELECT IN EXCHANGE FOR THE VALUE
              OFFERED.
            </li>
            <li>
              <strong>labelswap™</strong> WILL HAVE CUSTOMER PAYMENT AVAILABLE AT THE CONCLUSION OF THE PROCESS ONLY. CUSTOMER WILL RECEIVE
              A PHONE CALL, EMAIL, OR TEXT MESSAGE (ONE ONLY) INDICATING THE PROCESS HAS BEEN COMPLETED.
            </li>
            <li>
              ITEMS NOT SELECTED BY <strong>labelswap™</strong> WILL BE DONATED OR DISPOSED OF 24 HOURS AFTER NOTICE IS SENT TO YOU OF
              COMPLETION OF THE PROCESS. IF CUSTOMER CANNOT RETRIEVE ITEMS IN THIS PERIOD CUSTOMER MUST CONTACT THE
              STORE IMMEDIATELY. IF CUSTOMER CONTACTS THE STORE WITHIN 24 HOURS, THE ITEMS WILL BE HELD FOR AN ADDITIONAL
              24 HOURS ONLY AND WILL THEN BE DONATED OR DISPOSED OF. NO REQUESTS FOR ADDITIONAL EXTENSIONS OF TIME WILL
              BE HONORED.
            </li>
            <li>
              ONCE THE PROCESS HAS BEEN COMPLETED, CUSTOMER WILL NOT BE ABLE TO RECLAIM ITEMS FROM THE RACK, SHELVES OR
              DISPOSAL / DONATION BIN.
            </li>
            <li>
              CUSTOMER MUST PROVIDE VALID PHOTO IDENTIFICATION PAYMENT AND AS REQUIRED BY LAW.
              <p>
                BY SIGNING BELOW, CUSTOMER REPRESENTS, WARRANTS AND AGREES THAT: (1) HE OR SHE HAS CLEAR, UNENCUMBERED TITLE
                TO ALL PROPERTY BEING SOLD OR SWAPPED; (2)HAS THE RIGHT TO SELL OR SWAP THE PROPERTY TO <strong>LABELSWAP™</strong>; THAT ALL
                PROPERTY HAS BEEN LEGALLY OBTAINED; (3) THAT ALL BRANDED GOODS ARE GENUINE AND DO NOT INFRINGE ANY PATENT,
                TRADEMARK, COPYRIGHT OR OTHER INTELLECTUAL PROPERTY RIGHTS; AND, (4) ALL KNOWN MATERIAL DEFECTS HAVE BEEN
                DESCRIBED OR MADE KNOWN AND NOT CONCEALED.
              </p>
              <p>
                CUSTOMER AGREES TO INDEMNIFY AND HOLD (<strong>LABELSWAP™</strong>), ITS EMPLOYEES, OFFICERS, AND THE BUYER OF THE GOODS
                (THE “INDEMNIFIED PARTIES”) HARMLESS FROM ANY CLAIM TO OWNERSHIP OF THE GOODS SWAPPED BY CUSTOMER OR ANY CLAIM
                THAT THE GOODS VIOLATE THE INTELLECTUAL PROPERTY OF ANY PERSON OR ENTITY AND SHALL DEFEND AND INDEMNIFY EACH
                INDEMNIFIED PARTY INCLUDING PAYMENT OF DEFENSE COSTS AS INCURRED.
              </p>
              <p>
                CUSTOMER WAIVES ANY CLAIM AGAINST THE INDEMNIFIED PARTIES FOR ANY AND ALL LOSS OR DAMAGE TO CUSTOMER PROPERTY
                DURING THE DROP OFF PERIOD OR SALE PROCESS.  CUSTOMER AUTHORIZES <strong>LABELSWAP™</strong>, ITS ASSIGNS, SUCCESSORS, OR
                SERVICING AGENTS TO COMMUNICATE VIA SMS TEXT NOTIFICATION TO ANY NUMBER PROVIDED TO LABELSWAP.  CUSTOMER AGREES
                TO ACCEPT ANY AND ALL CHARGES OR FEES ASSOCIATED WITH MOBILE COMMUNICATION FROM <strong>LABELSWAP™</strong> INCLUDING FEES FROM
                MOBILE SERVICE PROVIDERS.
              </p>
            </li>
          </ul>
        </el-col>
      </el-row>
    </el-col>
  </el-row>
</template>

<script>
import { mapGetters } from 'vuex';

export default {
  name: 'ReceiptPage',
  data() {
    return {};
  },
  computed: {
    ...mapGetters('shopper', ['selectedShopper'])
  },
  async mounted() {
    const storedShopper = this.$store.getters['shopper/selectedShopper'];
    // Take user back to search if there is no selected shopper in the store
    if (!storedShopper) {
      this.$swal({
        type: 'error',
        title: 'Error',
        text: 'An error has occurred trying to access Swapper information. Please try again.'
      });
      this.$router.push('/home');
      return;
    }

    // Thank you message
    const { value } = await this.$swal({
      type: 'success',
      title: 'Thank You!',
      allowEscapeKey: false,
      allowOutsideClick: false,
      confirmButtonText: 'Print Receipt',
      // eslint-disable-next-line camelcase
      html: `<b>${storedShopper.first_name}</b>, thanks for shopping at labelswap.<br>Please flip the iPad to the store associate.`
    });
    if (value) {
      // Here we give half second for tha popup backdrop to fade out
      setTimeout(() => this.print(), 500);
    }
  },
  methods: {
    print() {
      window.print();
    },
    goHome() {
      this.$router.push('/home');
    },
  }
};

</script>
<style scoped lang="scss">
.logo-and-title {
  display: flex;
  justify-content: center;
  align-items: center;
  flex-direction: column;
}
.list {
  padding-left: 20px;
  &.custom-bullet {
    list-style: none;
    list-style-type: "- ";
  }
  li {
    margin-bottom: 4px;
  }
}
@media print {
  .hide-on-print {
    display: none;
  }
}
</style>